import {useState} from 'react';

/**
 * Are editor comments enabled in the timeline?
 * @param initialValue Starting value of the toggle (Optional, true if not provided)
 */

const useTimelineCommentaryEnabled = (
  initialValue?: boolean,
): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [commentaryEnabled, setCommentaryEnabled] = useState(initialValue ?? true);

  return [commentaryEnabled, setCommentaryEnabled];
};

export default useTimelineCommentaryEnabled;
